import { contentTypeJson } from "components/CommonLib/CommonLib";
import { HttpInstance } from "lib/HttpLib";

// [POST] 시재금 입출금 이력
export async function getVaultCashHist(queryData) {
  const { searchParams, isExcel } = queryData;

  // excel 다운로드 시 page_size 제거
  let newSearchParams = {
    ...searchParams,
    branch_ids: [...searchParams.branch_ids],
  };

  const { page_size, ...restSearchParams } = newSearchParams;

  if (isExcel) {
    newSearchParams = {
      ...restSearchParams,
    };
  }

  return await HttpInstance.post(
    process.env.REACT_APP_SALARY_SERVER + "/vault-cash/transactions/search",
    newSearchParams,
    contentTypeJson,
  );
}

// [GET] 시재금 잔액 조회
export async function getVaultCashBalance(queryData) {
  const { branchId } = queryData;

  return await HttpInstance.get(process.env.REACT_APP_SALARY_SERVER + `/vault-cash/${branchId}`);
}
